import { Badge, Button, Group, Skeleton, Table } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface TagGroup {
  id: string;
  name: string;
  tags: string[];
  editTime: string;
}

interface TagTableBodyProps {
  tagGroups: TagGroup[];
  onEdit: (item: TagGroup) => void;
  onDelete: (item: TagGroup) => void;
}

const TagTableBody = ({ tagGroups, onEdit, onDelete }: TagTableBodyProps) => {
  const { t } = useTranslation();

  const renderTagBadges = (tags: string[]) => {
    return (
      <Group gap="xs">
        {tags.map((tag, index) => (
          <Badge key={index} variant="light" size="md">
            {tag}
          </Badge>
        ))}
      </Group>
    );
  };

  return (
    <Table.Tbody>
      {tagGroups.map((item) => (
        <Table.Tr key={item.id} className="hover:bg-gray-50 transition-all">
          {(item as any).isLoading ? (
            <>
              <Table.Td>
                <Skeleton height={8} radius="xl" />
              </Table.Td>
              <Table.Td>
                <Skeleton height={8} radius="xl" />
              </Table.Td>
              <Table.Td>
                <Skeleton height={8} radius="xl" />
              </Table.Td>
              <Table.Td>
                <Skeleton height={8} radius="xl" />
              </Table.Td>
            </>
          ) : (
            <>
              <Table.Td>
                <Badge variant="filled" size="md">
                  {item.name}
                </Badge>
              </Table.Td>
              <Table.Td>{renderTagBadges(item.tags)}</Table.Td>
              <Table.Td>
                <span className="text-black font-light">{item.editTime}</span>
              </Table.Td>
              <Table.Td>
                <Group gap="xs">
                  <Button variant="subtle" size="xs" color="blue" onClick={() => onEdit(item)}>
                    {t('tag.edit')}
                  </Button>
                  <Button variant="subtle" size="xs" color="red" onClick={() => onDelete(item)}>
                    {t('tag.delete')}
                  </Button>
                </Group>
              </Table.Td>
            </>
          )}
        </Table.Tr>
      ))}
    </Table.Tbody>
  );
};

export default TagTableBody;
